String.prototype.rot13 = function () {
    return this.replace(/[a-zA-Z]/g, function(a){
        return String.fromCharCode(((a=a.charCodeAt())<91?78:110)>a?a+13:a-13);
    });
};

$(document).ready(function(){
    $('body').on('click', '[href^="mailto:"]:not(.email-obf__decoded):not(.dg3sht_mail)', function(){
        let mailtoHref = $(this).attr('href');
        let rotEmail = mailtoHref.substring('mailto:'.length);

        $(this).attr('href', 'mailto:' + rotEmail.rot13()).addClass('email-obf__decoded');
    });
});
